import { memoize } from './memoize'

function detectIntlDateTimeFormat(): boolean {
  try {
    new Intl.DateTimeFormat()
    return true
  } catch {
    console.log('Unsupported Intl DateTimeFormat')
    return false
  }
}

function detectIntlNumberFormat(): boolean {
  try {
    new Intl.NumberFormat()
    return true
  } catch {
    console.log('Unsupported Intl NumberFormat')
    return false
  }
}

function detectNumberFormatToParts(): boolean {
  if (!intlNumberFormat()) {
    console.log('Unsupported Intl')
    return false
  }

  const formatter = new Intl.NumberFormat()
  return typeof formatter.formatToParts === 'function'
}

function detectNumberFormat(): boolean {
  if (!intlNumberFormat()) {
    console.log('Unsupported Intl')
    return false
  }

  const formatter = new Intl.NumberFormat()
  return typeof formatter.format === 'function'
}

function detectDateTimeFormatToParts(): boolean {
  if (!intlDateTimeFormat()) {
    console.log('Unsupported Intl')
    return false
  }

  const formatter = new Intl.DateTimeFormat()
  return typeof formatter.formatToParts === 'function'
}

function detectDisplayNames(): boolean {
  try {
    const names = new Intl.DisplayNames(['en'], { type: 'region' })
    names.of('419')
    return true
  } catch {
    console.log('Unsupported Intl DisplayNames')
    return false
  }
}

export const intlDateTimeFormat = memoize(detectIntlDateTimeFormat)
export const intlNumberFormat = memoize(detectIntlNumberFormat)
export const numberFormatToParts = memoize(detectNumberFormatToParts)
export const numberFormat = memoize(detectNumberFormat)
export const dateTimeFormatToParts = memoize(detectDateTimeFormatToParts)
export const displayNames = memoize(detectDisplayNames)
